export const CHURCH_NAME = "IGLESIA DIA DE ADORACION";
export const CHURCH_TAGLINE = "Conectando a la Familia de Dios";

export default function ChurchBrand({ size = "md", showTagline = true, className = "" }) {
  const sizes = {
    sm: { name: "text-sm font-bold tracking-widest", tag: "text-xs italic" },
    md: { name: "text-base sm:text-lg font-bold tracking-widest", tag: "text-sm italic" },
    lg: { name: "text-xl sm:text-2xl font-bold tracking-widest", tag: "text-base italic" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`text-center ${className}`} data-testid="church-brand">
      <p className={`${s.name} font-serif`}>
        <span className="mr-1.5">⛪</span>
        {CHURCH_NAME}
      </p>
      {showTagline && (
        <p className={`${s.tag} font-serif opacity-90`}>{CHURCH_TAGLINE}</p>
      )}
    </div>
  );
}
